import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/LogoManagement.svg'


const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center text-sky-800"
}
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "italic" }
const _hoisted_5 = { class: "flex w-full flex-col gap-4 overflow-hidden overflow-y-auto" }
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_10 = {
  key: 0,
  class: "bottom-2 flex flex-col items-center gap-4"
}
const _hoisted_11 = { class: "font-bold text-sky-800" }
const _hoisted_12 = { class: "flex flex-col items-center justify-center gap-6" }
const _hoisted_13 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_14 = { class: "text-sm font-bold text-sky-800" }

import Icons from '@/components/subcomponents/Icons.vue'
import { hasPermission } from '@/composables/RequiredPermissions'
import { UserPermission } from '@/models/enums/permissions'
import { INavBarItem } from '@/models/navbar'
import { getAppVersion } from '@/services/appService'
import * as loginServices from '@/services/userService'
import { getUserName } from '@/services/userService'
import { getBackendVersion } from '@/services/versionService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useNavBarStore } from '@/stores/NavBarStore'
import { LogOut, PanelLeftOpen } from 'lucide-vue-next'
import PanelMenu from 'primevue/panelmenu'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import SelectLanguage from '../subcomponents/SelectLanguage.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const router = useRouter()
const navBar = useNavBarStore()
const languageStore = useLanguageStore()

const permissionsNavbarRouter = computed(() => {
  const filterRoutes = (routes: INavBarItem[]): INavBarItem[] => {
    return routes
      .map((route): INavBarItem | null => {
        const routeCopy = { ...route }

        if (route.items) {
          const filteredItems: INavBarItem[] = filterRoutes(route.items)
          routeCopy.items = filteredItems

          return filteredItems.length > 0 ? routeCopy : null
        }

        if (!route.hasOwnProperty('requiredPermission')) {
          return routeCopy
        }

        return route.requiredPermission && hasPermission(route.requiredPermission as UserPermission)
          ? routeCopy
          : null
      })
      .filter((item): item is INavBarItem => item !== null)
  }

  return filterRoutes(navBar.routes)
})

const logout = () => loginServices.logout(router)
const userName = getUserName()
const appVersion = getAppVersion()
const apiVersionLabel = ref('…')

onMounted(() => {
  void (async () => {
    try {
      const { data } = await getBackendVersion()
      apiVersionLabel.value = data.version
    } catch {
      apiVersionLabel.value = '—'
    }
  })()
})
const menuClasses = computed(() => [
  navBar.shown ? 'w-[20rem] grid grid-rows-[auto_1fr_auto]' : 'w-[4rem] flex flex-col',
  'gap-4 fixed left-0 top-0 z-50 h-screen bg-white p-2 shadow-lg transition-all duration-300',
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(menuClasses.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['flex items-center p-2', _unref(navBar).shown ? 'justify-end' : 'justify-center'])
      }, [
        _createVNode(_unref(PanelLeftOpen), {
          color: "#03619C",
          class: "cursor-pointer rounded-sm hover:bg-sky-100",
          onClick: _unref(navBar).toggle
        }, null, 8, ["onClick"])
      ], 2),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex w-full items-center justify-center py-4" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "w-32",
          alt: "logo"
        })
      ], -1)),
      (_unref(navBar).shown)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _cache[0] || (_cache[0] = _createTextVNode(" Olá, ", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(userName)) + "!", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(PanelMenu), {
        model: permissionsNavbarRouter.value,
        class: _normalizeClass([_unref(navBar).shown ? '' : 'flex items-center justify-center'])
      }, {
        item: _withCtx(({ item, props }) => [
          (item.to)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: item.to,
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createElementVNode("a", _mergeProps({ href: href }, props.action, {
                    onClick: navigate,
                    class: "flex h-10 items-center gap-2"
                  }), [
                    _createVNode(Icons, {
                      icon: item.icon,
                      class: "font-bold"
                    }, null, 8, ["icon"]),
                    (_unref(navBar).shown)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(languageStore).t(item.label as string)), 1))
                      : _createCommentVNode("", true)
                  ], 16, _hoisted_6)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(navBar).shown)
                  ? (_openBlock(), _createElementBlock("a", _mergeProps({ key: 0 }, props.action, { class: "flex h-10 items-center justify-between gap-2" }), [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(Icons, {
                          icon: item.icon,
                          class: "font-bold"
                        }, null, 8, ["icon"]),
                        (_unref(navBar).shown)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(languageStore).t(item.label as string)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(navBar).shown)
                        ? (_openBlock(), _createBlock(Icons, {
                            key: 0,
                            icon: "chevron-down",
                            class: "font-bold"
                          }))
                        : _createCommentVNode("", true)
                    ], 16))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      }, 8, ["model", "class"])
    ]),
    (_unref(navBar).shown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "flex cursor-pointer items-center justify-center gap-2 rounded-md bg-sky-100 p-2",
            onClick: logout
          }, [
            _createVNode(_unref(LogOut), {
              size: 16,
              "stroke-width": 2.5,
              color: "#03619C"
            }),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(languageStore).t('general.exit')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(SelectLanguage, { class: "mx-2" }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, "Version: " + _toDisplayString(_unref(appVersion)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})